import React from 'react';

import DriveloFooter from './DriveloFooter';

/**
 * Site footer on every page. Drivelo's footer is built in code (DriveloFooter) instead of
 * from the Console footer asset, so it no longer loads the page builder on every page.
 *
 * @component
 * @returns {JSX.Element}
 */
const FooterContainer = () => <DriveloFooter />;

export default FooterContainer;
